export const DEFAULT_ERROR_HEADER_TEXT = 'OOPS!';
export const DEFAULT_ERROR_BODY_TEXT =
  'Sorry, we are having some technical issues. Try again later.';
